// src/components/layout/Layout.js
import React from 'react';

const Layout = ({ children, currentRole }) => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* Header */}
      <header className="bg-[#fafa00] text-black px-4 py-1.5">
        <div className="container mx-auto flex justify-between items-center">
          <h1 className="text-xl font-bold">originzone</h1>

          {/* Removed the conditional rendering and the select dropdown */}
          {/* Always display the portal name based on currentRole */}
          <div className="text-sm font-medium">
            {currentRole === 'user' ? 'Trade Portal' : 'Account Manager Portal'}
          </div>
        </div>
      </header>
      
      {/* Main content */}
      <main className="flex-grow">
        {children}
      </main>
      
      {/* Footer */}
      <footer className="bg-gray-800 text-white p-4 text-center text-sm">
        <div className="container mx-auto">
          &copy; {new Date().getFullYear()} Originzone. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Layout;
